
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/outlet/fruits-vegetable-store",
      function () {
        return require("private-next-pages/outlet/fruits-vegetable-store.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/outlet/fruits-vegetable-store"])
      });
    }
  